<template lang="pug">
div.u-overflow
  .grid.is-widescreen-6.is-desktop-8.u-mt-sm.is-center
    .column

      h1.u-mb-sm {{$t('mantra')}}

      .form
        label.form-label {{$t('presets')}}

        Multiselect(
            v-model="selected"
            :options="[ 'Full HD 1080p','HD 720p', '4k HD' ,'Standard Monitor']"
            :searchable="false"
            :taggable="false"
            :multiple="false"
            :show-labels="false"
            :close-on-select="true"
            placeholder=""
          )

      .grid
        .column.u-mb-xs.is-6
          .form
            label.u-text-lg.form-label {{$t('wratio')}}
            input.input(type="number" v-model.number="widthRatio" @focus="freezeHeights" @blur="resetHeights")
            p.form-floatLabel PX


        .column.u-mb-xs.is-6
          .form
            label.u-text-lg.form-label {{$t('hratio')}}
            input.input(type="number" v-model.number="heightRatio"  @focus="freezeWidths" @blur="resetWidths")
            p.form-floatLabel PX

      .grid
        .column.u-mb-xs.is-6
          .form
            label.u-text-lg.form-label {{$t('pwith')}}
            input.input(type="number" v-model.number="pxWidth")
            p.form-floatLabel PX

        .column.u-mb-xs.is-6
          .form
            label.u-text-lg.form-label {{$t('pheight')}}
            input.input(type="number" v-model.number="pxHeight")
            p.form-floatLabel PX

      .u-textCenter.u-mb-xs
        button.button.is-white(@click="ratiosLocked = !ratiosLocked")
          template(v-if="ratiosLocked")
            AppIcon(name="lock")
            span {{$t('uratio')}}
          template(v-else)
            AppIcon(name="open-lock")
            span {{$t('lratio')}}


      p.ratio-result {{$t('rwidth')}} : #[span {{widthRatio}} ] , {{$t('rheight')}} : #[span {{ heightRatio }}]


  .ratioPreview.u-mt-sm.u-mb-md
    .ratioBox(:style="{width: pxWidth +'px', height: pxHeight + 'px'}")
      .ratioBox-h {{ pxHeight }}
      .ratioBox-w {{ pxWidth }}

</template>

<style lang="stylus">
.ratioBox-h
  position: absolute
  left: unitRes(-30, -60)
  top: 50%
  transform: translateY(-50%) rotate(-90deg)
  color: $clBlack

.ratioBox-w
  position: absolute
  top: unitRes(-30, -50)
  left: 50%
  transform: translateX(-50%)
  color: $clBlack

div.app
  &.is-aspecter
    background: $clDanger

    .header.is-scroll, .footer
      background: $clDanger
      background: $clDanger

    .form
      position: relative

    .form-floatLabel
      position: absolute
      height: $inputHeight
      background: $clWhite
      color: $clDanger
      position: absolute
      right: 0
      bottom: 0
      display: inline-flex
      align-items: center
      padding: 0 unitRes(10, 20)
      line-height: 1

    .buttons
      display: flex
      flex-wrap: wrap

.ratio-result
  background: rgba(0, 0, 0, 0.1)
  padding: unitRes(20, 40)
  text-align: center

  span
    color: $clBlack

.ratioPreview
  overflow: auto
  background: rgba(0, 0, 0, 0.1)
  padding: unitRes(40, 80)
  text-align: center

.ratioBox
  transition: all 0.3s ease 0.2s
  margin: 0 auto
  background-color: $clBlack
  position: relative

html[lang^='ar']
  div.app.is-aspecter .form-floatLabel
    right: auto
    left: 0
</style>

<script>
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { generateSeoMeta } from '~/utils/seo';

export default {
  head: generateSeoMeta({ title: 'pageTitle', description: 'pageDesc' }, { i18n: true }),
  meta: {
    theme: 'dark aspecter',
    logoText: 'ratios'
  },
  components: {
    Multiselect
  },
  data: () => ({
    selected: 'Standard Monitor',
    pxWidth: 1280,
    pxHeight: 960,
    widthRatio: 4,
    heightRatio: 3,
    heightsFrozen: false,
    widthsFrozen: false,
    ratiosLocked: true
  }),

  methods: {
    calcGCD(pxWidth, pxHeight) {
      if (pxHeight === 0) {
        return pxWidth;
      }
      return this.calcGCD(pxHeight, pxWidth % pxHeight);
    },
    cacluatePresetsRatios(pxWidth, pxHeight) {
      let gcd = this.calcGCD(pxWidth, pxHeight);
      this.widthRatio = pxWidth / gcd;
      this.heightRatio = pxHeight / gcd;
    },
    /*** */
    /* utils *
     *******************/
    freezeHeights() {
      if (this.ratiosLocked) return;
      this.heightsFrozen = true;
    },
    freezeWidths() {
      if (this.ratiosLocked) return;
      this.widthsFrozen = true;
    },
    resetHeights() {
      if (this.ratiosLocked) return;
      this.heightsFrozen = false;
    },
    resetWidths() {
      if (this.ratiosLocked) return;
      this.widthsFrozen = false;
    },
    calcPxHeight() {
      this.pxHeight = (this.pxWidth * this.heightRatio) / this.widthRatio;
    },
    calcPxWidth() {
      this.pxWidth = (this.pxHeight * this.widthRatio) / this.heightRatio;
    }
  },
  watch: {
    pxWidth(to) {
      if (!to || to <= 0) return (this.pxWidth = '');
      else if (!this.ratiosLocked && !this.heightsFrozen) {
        this.cacluatePresetsRatios(this.pxWidth, this.pxHeight);
      } else if (this.ratiosLocked) {
        this.calcPxHeight();
      }
    },
    pxHeight(to) {
      if (!to || to <= 0) return (this.pxHeight = '');
      else if (!this.ratiosLocked && !this.widthsFrozens) {
        this.cacluatePresetsRatios(this.pxWidth, this.pxHeight);
      } else if (this.ratiosLocked) {
        this.calcPxWidth();
      }
    },
    widthRatio(to) {
      if (!to) return;
      else if (this.heightsFrozen === true) {
        this.calcPxHeight();
      }
    },
    heightRatio(to) {
      if (!to) return;
      else if (this.widthsFrozen === true) {
        this.calcPxHeight();
      }
    },

    //** PRESETS */
    selected(value) {
      if (value === '4k HD') {
        this.pxWidth = 3840;
        this.pxHeight = 2160;
        this.cacluatePresetsRatios(3840, 2160);
      }
      if (value === 'Full HD 1080p') {
        this.pxWidth = 1920;
        this.pxHeight = 1080;
        this.cacluatePresetsRatios(1920, 1080);
      }
      if (value === 'HD 720p') {
        this.pxWidth = 1280;
        this.pxHeight = 720;
        this.cacluatePresetsRatios(1280, 720);
      }
      if (value === 'Standard Monitor') {
        this.pxWidth = 1280;
        this.pxHeight = 960;
        this.cacluatePresetsRatios(1280, 960);
      }
    }
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Ratios",
    "pageDesc":"Figuring ratios out in a blink. Enter the width and height to calculate the ratio needed for your next design project.",
    "mantra":"Aspect ratio",
    "presets":"Common Presets",
    "wratio":"Width Ratio",
    "hratio":"Height Ratio",
    "pwith":"Pixel Width",
    "pheight":"Pixel Height",
    "uratio":"Unlock ratio",
    "lratio":"Lock ratio",
    "rwidth":"Ratio Width",
    "rheight":"Ratio Height"
  },
  "ar": {
    "pageTitle":"النسب",
    "pageDesc":"حدد النسب في طرفة عين. أدخل العرض والارتفاع لحساب النسبة المطلوبة لتصميمك وسرع من أداء عملك وأنجزه بالشكل المطلوب",
    "mantra":"النسب",
    "presets":"الإعدادات المشتركة",
    "wratio":"نسبة العرض",
    "hratio":"نسبة الارتفاع",
    "pwith":"العرض بالبكسل",
    "pheight":"الطول بالبكسل",
    "uratio":"تحرير النسبة",
    "lratio":"تثبيت النسبة",
    "rwidth":"نسبة العرض",
    "rheight":"نسبة الطول"
  }
}
</i18n>
